module.exports = __webpack_public_path__ + "static/media/X.c2de960c.svg";